
import * as GraphExplorer from 'src/utils/graph/GraphExplorer'
import i18n from 'src/assets/messages';
import { Storage } from 'src/utils/storage/index';
import listeners from 'src/listeners';

import * as pathToRegexp from "path-to-regexp";

/**
 * [constructor description]
 * @return {[type]} [description]
 */
export class Emitter {

  /**
   * Listes des objects à mapper
   */
  public maps: any;

  /**
   * [constructor description]
   * @return {[type]} [description]
   */
  constructor() {
    this.maps = {};
  }

  /**
   * [use description]
   * @param  {[type]} key  [description]
   * @param  {[type]} func [description]
   * @return {[type]}      [description]
   */
  public on({ event, route, resolver }: { event: string, route?: any, resolver?: any }) {
    this.maps = this.maps || {};
    this.maps[event] = this.maps[event] || [];
    this.maps[event].push({ route, resolver });
  }

  /**
   * [emit description]
   * @param  {[type]}  key    [description]
   * @param  {[type]}  params [description]
   * @param  {[type]}  reduce [description]
   * @return {Promise}        [description]
   */
  public async emit({ event, input = {}, test, concat = false, onInput, stopOnFirstTest }: { event: string, concat?: boolean, input?: any, stopOnFirstTest?: any, test?: any, onInput?: any }) {
    let values: any = [];
    this.maps[event] = this.maps[event] || [];

    for (const elt of this.maps[event]) {
      if (typeof elt.resolver === 'function') {
        input.GraphExplorer = GraphExplorer;
        input.i18n = i18n;
        input.me = Storage.get('meCurrent');
        input.pathToRegexp = pathToRegexp;

        if (test && (typeof test === 'function')) {
          const t: boolean = test(elt);
          if (t === true) {
            if (typeof onInput === 'function') {
              input = onInput(input, elt);
            }
            const value: any = await elt.resolver(input);
            if (concat === true) {
              values = values.concat(value);
            } else {
              values.push(value);
            }
            if (stopOnFirstTest === true) {
              return values;
            }
          }
        } else {
          if (typeof onInput === 'function') {
            input = onInput(input, elt);
          }
          const value: any = await elt.resolver(input);
          if (concat === true) {
            values = values.concat(value);
          } else {
            values.push(value);
          }
        }
      }
    }

    return values;
  }
}

const emitter = new Emitter();
for (const middleware of listeners) {
  try {
    if (typeof middleware === 'function') {
      middleware(emitter);
    }
  } catch (e) {
    console.error(e);
  }
}

export const emitWithRouter = async ({ event, input = {} }: { event: string, input?: any }) => {
  return await emitter.emit({
    event,
    input,
    concat: true,
    stopOnFirstTest: true,
    onInput: (inp: any, { route }: any) => {
      let rt = route;
      if (typeof route === 'object') {
        for (const r of route) {
          const regX: any = pathToRegexp(r);
          if (regX.test(window.location.pathname) === true) {
            rt = r;
          }
        }
      }

      const keys: any[] = [];
      const re = pathToRegexp(rt, keys);
      const ids: any = re.exec(location.pathname);

      // Add value
      const mt: any = {};
      for (const k of keys) {
        const i = keys.indexOf(k);
        mt[keys[i].name] = ids[i + 1];
      }

      inp.routeParams = mt;
      return inp;
    },
    test: ({ route }: any) => {
      // Object testing
      if (typeof route === 'object') {
        let tested: boolean = false;
        for (const r of route) {
          const re = pathToRegexp(r);
          if (re.test(window.location.pathname) === true) {
            tested = true;
          }
        }
        return tested;
      } else {
        const re = pathToRegexp(route);
        return re.test(window.location.pathname);
      }
    }
  });
}

export const emit = async ({ event, input = {} }: { event: string, input?: any }) => {
  return await emitter.emit({
    event,
    input,
    concat: true,
  });
}

export default emitter;


// WEBPACK FOOTER //
// ./src/utils/emitter.ts